import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as invoiceApi from '../../api/invoice';
import { unitsAction } from '../../redux/actions';

function ManagerServiceInvoice() {
    const dispatch = useDispatch();
    const token = useSelector(state => state.token);
    const auth = useSelector(state => state.auth);
    const branchID = auth && auth.user ? auth.user.branchID : null;

    const [month, setMonth] = useState(new Date().toISOString().slice(0,7));
    useHistory();
    const [data, setData] = useState([]);
    useState(null);
    const [, setLastResponse] = useState(null);
    const [errorMsg, setErrorMsg] = useState("");
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        if (!branchID) return;
        loadByMonth(month);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branchID, month]);

    function getInvoiceId(item) {
        return item.invoice_id || item._id || item.id || item.si_id || 'N/A';
    }

    const filteredData = data.filter(item => {
        if (!searchText) return true;
        const s = searchText.toString().toLowerCase();
        const fields = [item.service, item.room, item.invoice_id, item.name];
        return fields.some(f => f && f.toString().toLowerCase().includes(s));
    });

    const loadByMonth = (m) => {
        const run = async () => {
            try {
                dispatch(unitsAction.showLoading());
                const res = await invoiceApi.takeServiceSIbyMonth(branchID, m, token);
                setLastResponse(res && res.data ? res.data : res);
                dispatch(unitsAction.hiddenLoading());
                if (res && res.data && res.data.status === 1) {
                    setData(res.data.data || []);
                    setErrorMsg("");
                } else {
                    setData([]);
                    setErrorMsg(res && res.data && res.data.msg ? res.data.msg : 'No data or error from API');
                }
            } catch (err) {
                dispatch(unitsAction.hiddenLoading());
                setData([]);
                setErrorMsg(err && err.message ? err.message : 'Fetch error');
                setLastResponse(err && err.response ? err.response.data : null);
            }
        }
        run();
    }

    return (
        <div>
            <h1 className="mt-4">Service Invoice Manager - Branch {branchID}</h1>
            <div className="d-flex align-items-center mb-3" style={{fontSize:"1.5rem"}}>
                <label style={{marginRight:8}}>Select month:</label>
                <input type="month" value={month} onChange={e => setMonth(e.target.value)} />
            </div>

            <div>
                {errorMsg ? <div className="text-danger">{errorMsg}</div> : null}
                <div className="mb-2 d-flex align-items-center">
                    <input placeholder="Search service/room/invoice/name" className="form-control form-control-sm" style={{maxWidth:360, fontSize: "1.5rem"}} value={searchText} onChange={e=>setSearchText(e.target.value)} />
                </div>
                {filteredData.length === 0 ? <h2>No service invoices for selected month.</h2> : (
                    <table className="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Invoice Id</th>
                                <th>Version</th>
                                <th>Date</th>
                                <th>Room</th>
                                <th>Service</th>
                                <th>Name</th>
                                <th>Amount</th>
                                <th>Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item, idx) => (
                                <React.Fragment key={idx}>
                                    <tr>
                                        <td>{idx+1}</td>
                                        <td>{getInvoiceId(item)}</td>
                                        <td><strong>{item.version || 1}</strong></td>
                                        <td>{item.date ? new Date(item.date).toLocaleDateString() : (item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A')}</td>
                                        <td>{item.room || ''}</td>
                                        <td>{item.service || ''}</td>
                                        <td>{item.name || item.customer_name || item.guest || 'N/A'}</td>
                                        <td>{item.vnd || item.total || item.amount || item.price || 'N/A'}</td>
                                        <td>
                                            <button className="btn btn-sm btn-primary" 
                                           onClick={() =>   window.open(
                                                `/service_invoice/${branchID}/${getInvoiceId(item)}/${item.version || 1}`,
                                                '_blank',
                                                'noopener,noreferrer'
                                            )}> Open </button>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )
}

export default ManagerServiceInvoice;
